import { render, staticRenderFns } from "./OtherbillarList.vue?vue&type=template&id=31864c9e"
import script from "./OtherbillarList.vue?vue&type=script&lang=js"
export * from "./OtherbillarList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports